import React from 'react';

const RecentInteractions = () => {
  const interactions = [
    {
      date: '08-01-2023',
      type: 'Email',
      summary: 'Discussed options for home loan refinancing',
      status: 'Review Emailed Options'
    },
    {
      date: '05-01-2023',
      type: 'Call',
      summary: 'Shared investment portfolio performance',
      status: 'Schedule Follow-up Call'
    }
  ];

  return (
    <div className="bg-[#1A1A1A] p-6 rounded-xl border border-[#2A2A2A] shadow-xl">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-[#FFFFFF]">Recent Interactions</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="text-left text-sm text-[#B4E50D]">
              <th className="pb-2">Date</th>
              <th className="pb-2">Type</th>
              <th className="pb-2">Summary</th>
              <th className="pb-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {interactions.map((interaction, index) => (
              <tr key={index} className="border-t border-[#3A3A3A]">
                <td className="py-2 text-sm text-[#FFFFFF]">{interaction.date}</td>
                <td className="py-2 text-sm text-[#FFFFFF]">{interaction.type}</td>
                <td className="py-2 text-sm text-[#B0B0B0]">{interaction.summary}</td>
                <td className="py-2">
                  <span className="px-2 py-1 bg-[#B4E50D] text-[#0A0A0A] rounded-full text-xs font-medium">
                    {interaction.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 text-right">
        <button className="text-[#B4E50D] text-sm hover:text-[#B4E50D] hover:underline transition-colors">
          view all activity →
        </button>
      </div>
    </div>
  );
};

export default RecentInteractions;